import React from 'react';
import { SimpleTag } from '@atlaskit/tag';
import TagGroup from '@atlaskit/tag-group';
import { ff } from '@atlassian/jira-feature-flagging';
import { getTagColor } from '@atlassian/jira-servicedesk-customer-service-common';
import type { ReadViewProps } from '../../../types';

export const MultiSelectFieldReadView = ({
	render,
	values,
	formattedOptions,
	getValueContainer,
	inInlineEdit,
}: ReadViewProps) => {
	const ValueContainer = getValueContainer();

	const formattedValues =
		values?.map((value) => {
			const formattedValue = formattedOptions?.find((option) => option.value === value);
			return {
				label: value,
				color: getTagColor(formattedValue?.color),
			};
		}) ?? [];

	return (
		<ValueContainer
			noVerticalPaddingWhenNotEmpty
			render={
				render ||
				(() => {
					if (!values || !values?.length) {
						return null;
					}

					return (
						<TagGroup>
							{ff('shipit-58-colours-for-detail-fields-in-csm_i6j6e')
								? formattedValues.map((value, i) => (
										<SimpleTag
											text={value.label}
											key={i}
											color={value.color}
											testId="servicedesk-customer-service-custom-details.common.ui.field.select-field.multi.read-view.multi-select-field-read-view-tag"
										/>
									))
								: values?.map((value, i) => <SimpleTag text={value} key={i} color="greyLight" />)}
						</TagGroup>
					);
				})
			}
			noBorder={inInlineEdit}
		/>
	);
};
